import axiosInstance from "../interceptor/interceptor";
import applicationDetailsDictionary from "../dictionary/applicationDetailsDictionary";

const applicationDetailsServices = {
  getApplicationLoanDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(
      applicationDetailsDictionary.getApplicationLoanDetails(),
      { applicantId, trackingId }
    ),
  getAcademicDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getAcademicDetails(), {
      applicationId,
      trackingId,
    }),
  getEmploymentDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getEmploymentDetails(), {
      applicantId,
      trackingId,
    }),
  getEntranceDetails: (
    applicationId: string,
    applicantId: string,
    trackingId: string
  ) =>
    axiosInstance.post(applicationDetailsDictionary.getEntranceDetails(), {
      applicationId,
      applicantId,
      trackingId,
    }),
  getLoanDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getLoanDetails(), {
      applicantId,
      trackingId,
    }),
  getExpenseDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getExpenseDetails(), {
      applicationId,
      trackingId,
    }),
  getReferenceDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getReferenceDetails(), {
      applicationId,
      trackingId,
    }),
  getCoApplicantDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getCoApplicantDetails(), {
      applicationId,
      trackingId,
    }),
  getCoApplicantBasicDetails: (applicantId: string, trackingId: string) =>
    axiosInstance.post(
      applicationDetailsDictionary.getCoApplicantBasicDetails(),
      { applicantId, trackingId },
    ),
  getCoApplicantCompletionRate: (trackingId: string) =>
    axiosInstance.post(
      applicationDetailsDictionary.getCoApplicantCompletionRate(),
      {
        trackingId,
      }
    ),
  getCollateralDetails: (applicationId: string, trackingId: string) =>
    axiosInstance.post(applicationDetailsDictionary.getCollateralDetails(), {
      applicationId,
      trackingId,
    }),
  deleteCoApplicant: (trackingId: string, coApplicantType: string) =>
    axiosInstance.post(applicationDetailsDictionary.deleteCoApplicant(), {
      trackingId,
      coApplicantType,
    }),
  // processioDeleteCoApplicant: (payload: any) =>
  //   axiosInstance.post(
  //     applicationDetailsDictionary.processioDeleteCoApplicant(),
  //     payload,
  //   ),

  // New API for summary completion
  completeSummary: (trackingId: string) =>
    axiosInstance.get(
      `api/v1/form-submission-completion/summary/${trackingId}`
    ),
  getAdditionalDetails:(trackingId:string)=>
     axiosInstance.get(
      `api/v1/processio/getLoanDetailsFromProcessio/${trackingId}`
    ),
  documentCompletion:(trackingId:string)=>
     axiosInstance.get(
      `api/v1/journey-master-document/document-completion/${trackingId}`
    ),
};

export default applicationDetailsServices;
